import { Dropdown, DropdownGroup, DropdownItem, DropdownList, MenuToggle, } from '@patternfly/react-core';
import { EllipsisVIcon } from '@patternfly/react-icons';
import React from 'react';
;
export var ActionMenuVariant;
(function (ActionMenuVariant) {
    ActionMenuVariant["KEBAB"] = "plain";
    ActionMenuVariant["DROPDOWN"] = "default";
})(ActionMenuVariant || (ActionMenuVariant = {}));
;
;
export const ActionMenu = ({ // replace deprecated
actions = [], groupedActions = [], isDisabled, variant = ActionMenuVariant.DROPDOWN, label = 'Actions', popperProps, id = 'actions', }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const onToggle = () => setIsOpen(!isOpen);
    const onFocus = () => {
        const element = document.getElementById(`toggle-menu-${id}`);
        if (element) {
            element.focus();
        }
        ;
    };
    const onSelect = () => {
        setIsOpen(false);
        onFocus();
    };
    return (React.createElement(Dropdown, { isOpen: isOpen, onSelect: onSelect, popperProps: popperProps, toggle: (toggleRef) => React.createElement(MenuToggle, { ref: toggleRef, id: `toggle-menu-${id}`, onClick: onToggle, isDisabled: isDisabled, variant: variant, isExpanded: isOpen }, variant === ActionMenuVariant.DROPDOWN ? label : React.createElement(EllipsisVIcon, null)) },
        actions.length > 0 ?
            React.createElement(DropdownList, null, actions.map((action) => React.createElement(DropdownItem, Object.assign({}, action, { description: action.description, isDisabled: action.isDisabled, value: action.itemId, onClick: action.onClick, tooltipProps: action.tooltipProps, key: action.itemId }), action.children))) : null, groupedActions === null || groupedActions === void 0 ? void 0 :
        groupedActions.map((action) => (React.createElement(DropdownGroup, { label: action === null || action === void 0 ? void 0 : action.label, key: action.groupId },
            React.createElement(DropdownList, null, action.actions.map((action) => React.createElement(DropdownItem, Object.assign({}, action, { description: action.description, isDisabled: action.isDisabled, value: action.itemId, onClick: action.onClick, tooltipProps: action.tooltipProps, key: action.itemId }), action.children))))))));
};
export default ActionMenu;
